/* v8 ignore file -- @preserve */
import _AppWorker from './worker';
import type { IDBWorker } from './workerScript/idbWorker';
import IDBWorkerScript from './workerScript/idbWorker/idbWorker?worker&inline';
import type { ImageFetchWorker } from './workerScript/imageFetchWorker';
import ImageFetchWorkerScript from './workerScript/imageFetchWorker/imageFetchWorker?worker&inline';
import type { PCDWorker } from './workerScript/pcdWorker';
import pcdWorkerScript from './workerScript/pcdWorker/pcdWorker?worker&inline';

const appWorker = new _AppWorker()
  .terminateAll()
  .add<'idb', IDBWorker>('idb', IDBWorkerScript)
  .add<'imageFetch', ImageFetchWorker>('imageFetch', ImageFetchWorkerScript)
  .add<'pcd', PCDWorker>('pcd', pcdWorkerScript);

type AppWorker = Omit<
  typeof appWorker,
  '_load' | '_registerCallback' | '_setOnMessage'
>;

export * from './workerScript/labelingBoxShared';
export default appWorker as AppWorker;
